export default __webpack_public_path__ + "static/media/airtime-dark.30b33227.png";